// @flow

require('@babel/polyfill');
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux'
import { createStore } from 'redux'
import Crop from '../components/Crop';
import reducer from '../components/Crop/reducer';

const store = createStore(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
const cropper = document.getElementById('cropper');
ReactDOM.render(<Provider store={store}><Crop /></Provider>, cropper);
